import React from 'react';
import cn from "classnames";
import CONFIG from "../../config";

const { LINKS } = CONFIG;

interface IAbout {
    className?: string;
}

const About: React.FC<IAbout> = ({ className }) => (
    <ul className={cn(className)}>
        <li><a href={LINKS.BAIBOL.ABOUT} target="_blank" rel="noopener noreferrer nofollow">О компании</a></li>
        <li><a href={LINKS.BAIBOL.DOCUMENTS} target="_blank" rel="noopener noreferrer nofollow">Документы компании</a></li>
        <li><a href={LINKS.BAIBOL.JOB} target="_blank" rel="noopener noreferrer nofollow">Вакансии Байбол</a></li>
        <li><a href={LINKS.BAIBOL.OFFICES} target="_blank" rel="noopener noreferrer nofollow">Отделения</a></li>
    </ul>
);

export default About;
